<template>
  <div class="login-wrapper">
    <!-- START Login Background Pic Wrapper-->
    <div class="bg-pic">
      <!-- START Background Pic-->
      <img src="~assets/img/bg-buildings.jpg" alt="" class="lazy">
      <!-- END Background Pic-->
      <!-- START Background Caption-->
      <div class="bg-caption pull-bottom sm-pull-bottom text-white p-l-20 m-b-20">
        <h2 class="semi-bold text-white" v-html="slogan"></h2>
        <p class="small">
          All Rights Reserved. © 2018 <span v-html="brand"></span>
        </p>
      </div>
      <!-- END Background Caption-->
    </div>
    <!-- END Login Background Pic Wrapper-->
    <!-- START Login Right Container-->
    <div class="login-container bg-white">
      <div class="p-l-50 m-l-20 p-r-50 m-r-20 p-t-50 m-t-30 sm-p-l-15 sm-p-r-15 sm-p-t-40">
        <div class="logo-container">
          <img class="logo" src="~assets/img/logo_dark.png"></img>
        </div>
        <p class="p-t-35">Sign into your <span v-html="brand"></span> account</p>
        <!-- START Login Form -->
        <form v-on:submit.prevent="validateBeforeSubmit()" id="form-login" class="p-t-15" role="form">
          <pg-input :initialValue="email" ref="email" label="Login" name="email" placehodler="Email" validations="required|email"></pg-input>
          <pg-input :initialValue="password" ref="password" type="password" label="Password" name="password" placehodler="Password" validations="required"></pg-input>
          
          <!-- START Form Control-->
          <div class="row">
            <div class="col-md-6 no-padding">
              <pg-checkbox label="Keep Me Signed In" :value="true"></pg-checkbox>
            </div>
            <div class="col-md-6 text-right hide">
              <a href="#" class="text-info small">Help? Contact Support</a>
            </div>
          </div>
          <!-- END Form Control-->
          <pg-button @click.native="validateBeforeSubmit()" submit cls="m-t-15">Sign in</pg-button>
        </form>
        <!--END Login Form-->
        <div class="pull-bottom sm-pull-bottom">
          <div class="m-b-30 p-r-80 sm-m-t-20 sm-p-r-15 sm-p-b-20 clearfix">
            <div class="col-sm-9 no-padding m-t-10">
              <p>
                <small>
                If you have any questions or need help, please contact <a href="" class="text-info">our support</a>
              </small>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END Login Right Container-->
  </div>
  
</template>

<script>  

  export default {
    name: "Login",    
    props: {
      brand: {
        type: String,
        default: 'Brand'
      },
      slogan: {
        type: String,
        default: ''
      }
    },
    data: () => ({
      email: '',
      password: ''
    }),
    methods: {
      validateBeforeSubmit() {
        if (!this.$refs.email.errors.any() ||
            !this.$refs.password.errors.any()) {
          this.signIn();
        }
      },
      signIn() {        
        this.$emit('login', { 
          email: this.$refs.email.value, 
          password: this.$refs.password.value 
        });
      }
    }
  }
</script>

<style>

  .logo-container {
  }

  img.logo {
    width: 100%;    
    margin: 0;
  }
</style>


// WEBPACK FOOTER //
// login.vue?7f2b4b89